export const calculateEstimatedLabelWidth = (categories: string[]) => {
  const width =
    categories.reduce((acc, curr) => {
      return acc + (curr.length * letterWidth || 0);
    }, 0) / categories.length;

  if (width > maxValue) {
    return maxValue;
  }

  if (width < minValue) {
    return minValue;
  }

  return width + additionalPadding;
};

const letterWidth = 6.5;
const minValue = 50;
const maxValue = 110;
const additionalPadding = 12;
